// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__-nvDl","content":"default_content__9AfZV","header":"default_header__yQ+Oh","table":"default_table__ixa1Y"};